import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { forwardRef as x } from "react";
import { tv as h } from "../../tailwind-variants.config.js";
import { ErrorMessage as y } from "../../ErrorMessage/index.js";
const v = "_root_iycyi_2", N = {
  root: v
}, E = h({
  base: "jm-flex jm-gap-2 jm-h-11 jm-pl-4 jm-pr-2 jm-rounded-lg jm-bg-white jm-outline-none jm-ring-0 jm-border jm-border-solid has-[:focus]:jm-border-jutro-new-blue-700 has-[:disabled]:jm-bg-jutro-new-warm-gray-100 jm-w-fit jm-box-border jm-text-jutro-new-warm-gray-800 jm-border-jutro-new-warm-gray-500",
  variants: {
    error: {
      true: "has-[:focus]:jm-border-transparent jm-border-transparent jm-outline jm-outline-offset-0 jm-outline-2 jm-outline-jutro-new-rose-500"
    }
  }
}), L = x((t, d) => {
  const {
    name: o,
    label: a,
    onChange: j,
    placeholder: c,
    disabled: u,
    error: m,
    maxLength: f,
    onFocus: n,
    prefixElement: l,
    suffixElement: s,
    ...g
  } = t, b = E({
    error: !!m
  }), w = typeof m == "string";
  return /* @__PURE__ */ i("div", { className: `jm-font-geologica jm-grid jm-gap-1 ${N.root}`, children: [
    a && /* @__PURE__ */ e(
      "label",
      {
        htmlFor: o,
        className: "jm-font-label jm-block jm-w-fit jm-text-jutro-new-warm-gray-800",
        children: a
      }
    ),
    /* @__PURE__ */ e("div", { className: b, children: /* @__PURE__ */ i("div", { className: "jm-flex jm-w-fit jm-gap-2 jm-text-inherit", children: [
      l && /* @__PURE__ */ e("div", { className: "jm-font-label jm-flex jm-items-center jm-border-none peer-disabled:jm-text-jutro-new-warm-gray-800", children: l }),
      /* @__PURE__ */ e(
        "input",
        {
          ...g,
          onFocus: (r) => {
            n == null || n(r), r.target.addEventListener("wheel", (p) => p.preventDefault());
          },
          inputMode: "numeric",
          ref: d,
          id: o,
          name: o,
          type: "text",
          placeholder: c,
          value: t.value,
          onChange: (r) => {
            j && j(r);
          },
          disabled: u,
          className: `jm-peer jm-font-paragraph-1 jm-w-[62px] jm-flex-grow jm-border-none jm-p-0 jm-tracking-wider jm-text-inherit placeholder:jm-text-jutro-new-warm-gray-500 focus:jm-border-transparent focus:jm-outline-none focus:jm-ring-0 disabled:jm-bg-jutro-new-warm-gray-100 ${t.value ? "jm-text-center" : "jm-text-left"}`,
          maxLength: f
        }
      ),
      s && /* @__PURE__ */ e("div", { className: "jm-font-label jm-flex jm-items-center jm-border-none peer-disabled:jm-text-jutro-new-warm-gray-800", children: s })
    ] }) }),
    w && /* @__PURE__ */ e(y, { error: m })
  ] });
});
export {
  L as Input
};
//# sourceMappingURL=index.js.map
